// extracted by mini-css-extract-plugin
export default {"zr-main-container":"App_zr-main-container__vpC8-","zr-main-content":"App_zr-main-content__w-nDL","zr-fullscreen":"App_zr-fullscreen__E1Q5I"};